import { render, staticRenderFns } from "./IlluOutilsPedagogiques.vue?vue&type=template&id=ff09db4c&"
import script from "./IlluOutilsPedagogiques.vue?vue&type=script&lang=js&"
export * from "./IlluOutilsPedagogiques.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports